import Heading from "./heading/Heading";
import TextStyle from "./textStyle/TextStyle";
import CodeBlock from "./codeBlock/CodeBlock";
import BulletList from "./bulletList/BulletList";
import OrderedList from "./orderedList/OrderedList";
import InfoBox from "./infoBox/InfoBox";
import BlockQuote from "./blockQuote/BlockQuote";
import TextAlign from "./textAlign/TextAlign";
import Code from "./code/Code";
import Strikethrough from "./strikethrough/Strikethrough";
import Bold from "./bold/Bold";
import Underline from "./underline/Underline";
import Italic from "./italic/Italic";
import Link from "./link/Link";
import VideoEmbed from "./videoEmbed/VideoEmbed";
import Image from "./image/Image";
import Paragraph from "./paragraph/Paragraph";
import Text from "./text/Text";
import HardBreak from "./hardBreak/HardBreak";
import Placeholder from "./placeholder/Placeholder";

export default {
    paragraph: Paragraph,
    text: Text,
    hardBreak: HardBreak,
    heading: Heading,
    textStyle: TextStyle,
    codeBlock: CodeBlock,
    bulletList: BulletList,
    orderedList: OrderedList,
    infoBox: InfoBox,
    blockQuote: BlockQuote,
    textAlign: TextAlign,
    code: Code,
    strikethrough: Strikethrough,
    bold: Bold,
    underline: Underline,
    italic: Italic,
    link: Link,
    videoEmbed: VideoEmbed,
    image: Image,
    placeholder: Placeholder,
}